import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import PayrollService from "../../services/PayrollService";

const initialState = {
  data: {},
  columnConfig: [],
  status: "idle",
  formData: {
    usersList: [],
  },
};

export const fetchContractorPayrun = createAsyncThunk("contractorPayrun", async () => {
  const response = await PayrollService.getContractorPayrollByPage();
  return response;
});

export const fetchContractors = createAsyncThunk("contractors", async () => {
  const response = await PayrollService.getContractorList();
  return response;
});



export const ContractorPayrollSlice = createSlice({
  name: "contractorPayroll",
  initialState,
  reducers: {
    addPayrollColumnConfig: (state, action) => {
      const configs = action.payload;
      let configsToStore = [];
      configs.forEach((config) => {
        configsToStore.push({
          ...config,
          key: config.columnCode,
          options: config.options ? config.options : [],
        });
      });
      state.columnConfig = configsToStore;
    },
    addColumnToPayrollColumnConfig: (state, action) => {
      state.columnConfig = [...state.columnConfig, action.payload];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchContractorPayrun.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchContractorPayrun.fulfilled, (state, action) => {
        state.status = "idle";
        state.data = action.payload;
      })
      .addCase(fetchContractors.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchContractors.fulfilled, (state, action) => {
        state.status = "idle";
        state.formData.usersList = action.payload;
      });
  },
});

export const { addPayrollColumnConfig, addColumnToPayrollColumnConfig } =
  ContractorPayrollSlice.actions;

export const selectContractorPayroll = (state) => state.contractorPayroll.data;

export const selectContractors = (state) => state.contractorPayroll.formData.usersList;



export default ContractorPayrollSlice.reducer;
